import { useTranslation } from 'react-i18next';

import { SwitchChannelAction } from '@/shared/types/action';
import { switchChannelName } from '@/util/switchChannel';

const SwitchChannel = ({ action }: { action: SwitchChannelAction }) => {
  const { t } = useTranslation();
  return (
    <span className="text-sm leading-5 font-normal text-foreground-muted">
      {t('dialog.switch_channel.to', { 0: switchChannelName(t, action.channel) })}
    </span>
  );
};

export default SwitchChannel;
